import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { HammerIcon, GridIcon, TrendingUpIcon, SquareIcon, ZapIcon, LayersIcon, PaintbrushIcon, WrenchIcon, ClipboardListIcon } from 'lucide-react';
const services = [{
  title: 'Carpentry',
  description: 'Custom woodwork, framing, and structural repairs for commercial spaces.',
  icon: HammerIcon
}, {
  title: 'Tiling',
  description: 'Professional installation and repair of floor and wall tiles.',
  icon: GridIcon
}, {
  title: 'Business Improvement Consulting',
  description: 'Strategic advice to optimize your facility for operational efficiency.',
  icon: TrendingUpIcon
}, {
  title: 'Drywall Installation & Repairs',
  description: 'Seamless drywall patching, installation, and finishing services.',
  icon: SquareIcon
}, {
  title: 'Electrical',
  description: 'Safe and compliant electrical maintenance and upgrades.',
  icon: ZapIcon
}, {
  title: 'Flooring',
  description: 'Durable commercial flooring installation and maintenance.',
  icon: LayersIcon
}, {
  title: 'Painting',
  description: 'Interior and exterior commercial painting with premium finishes.',
  icon: PaintbrushIcon
}, {
  title: 'Plumbing',
  description: 'Reliable plumbing repairs and system maintenance.',
  icon: WrenchIcon
}, {
  title: 'Project Management',
  description: 'End-to-end oversight ensuring projects are on time and on budget.',
  icon: ClipboardListIcon
}];
export function ServicesSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="services" className="py-24 bg-warm-grey" data-id="element-192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-194">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-3 mb-4" data-id="element-195">
            <div className="h-[1px] w-8 bg-border" data-id="element-196" />
            <span className="text-primary text-xs font-bold tracking-widest uppercase" data-id="element-197">
              What We Do
            </span>
            <div className="h-[1px] w-8 bg-border" data-id="element-198" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-199">
            Residential and Commercial Renovations, Construction & Maintenance
            Services
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-body" data-id="element-200">
            From minor repairs to full project oversight, we proactively manage
            maintenance to reduce downtime and extend the life of your assets.
          </motion.p>
        </div>

        {/* Services Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-201">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={cardVariants} className="group bg-white rounded-lg p-8 border border-border/50 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" data-id="element-202">
                <div className="w-12 h-12 rounded-lg bg-warm-grey flex items-center justify-center mb-6 group-hover:bg-primary/5 transition-colors" data-id="element-203">
                  <Icon className="w-6 h-6 text-primary transition-colors" data-id="element-204" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-205">
                  {service.title}
                </h3>
                <p className="text-body leading-relaxed" data-id="element-206">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}